import type { ProfileSubPageMessage } from "@albertine/types";
import { parentOriginFromLocation, postMessageToParentFrame } from "@/lib/parentFrame";

export function postProfileSubPageMessage(message: ProfileSubPageMessage) {
    postMessageToParentFrame(parentOriginFromLocation(), message);
}

export function setProfileSubPageBodyColors(top: string, bottom: string) {
    document.documentElement.style.setProperty("--color-body-top", top);
    document.documentElement.style.setProperty("--color-body-bottom", bottom);
}
